/**
 * 初始化命名空间
 */
// 初始化参数工厂
if (!window.PrmFactory) window.PrmFactory = {};
// 初始化参数工厂
if (!window.SAPrmFactory) window.SAPrmFactory = {};
// 初始化配置
if (!window.sgiConfig) window.sgiConfig = {};
// 初始化组件管理器
if (!window.ComponentManager) window.ComponentManager = {};
// 初始化antd组件库
if (!window.sgiAntdModule) window.sgiAntdModule = {};
// 初始化自定义组件库
if (!window.sgiCustomModule) window.sgiCustomModule = {};
// 初始化标准代码管理器
if (!window.StandardCode) window.StandardCode = {};
// 初始化工具集
if (!window.tool) window.tool = {};
// 初始化资源管理器
if (!window.Resource) window.Resource = {};
// 初始化SgiComp和Dnd_SgiComp组件库，通过key获取组件
if (!window.sgiModule) window.sgiModule = {};


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCommon/InitNameSpace.js